// Styles for CobrandWrapper go here.
import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledCobrandWrapper = styled.div`
  ${rtl`
    .variable_column_header{
      margin:0;
      p{
        margin-bottom:0;
      }
    }
    .cobrand-wrapper-height{
       min-height:${toRem(4400)};
      @media ${baseVariables?.mediaQuery?.md} {
       min-height:${toRem(6300)};
      }
      @media ${baseVariables?.mediaQuery?.lg} {
       min-height:${toRem(5300)};
      }
    }
    .vcc-container{
      margin-bottom:0;
    }
    .full-skeleton-block {
      border: ${baseVariables.border.borderWidth02} ${baseVariables.border.borderStyleDefault}
              ${baseVariables.color.neutral20};
      border-radius: ${toRem(16)};
      box-shadow: 0 ${toRem(4)} ${toRem(20)} ${baseVariables.shadows.boxShadowTile};
      overflow: hidden;
      .react-loading-skeleton {
        --pseudo-element-display:true;
      }
    }
  `}
`;
